// extracted by mini-css-extract-plugin
export default {"parent":"loader_parent__PPJ0l","lds_ring":"loader_lds_ring__ADBzQ","lds-ring":"loader_lds-ring__40DfZ"};